<template>
  <div class="homeDemo w-full">
    <div class="auto-container flex flex-wrap w-full gap-3">
      <div class="flex w-full lg:w-6">
        <div class="homepage-title-group">
          <span class="sectionTitle white" v-html="titulo"></span>
          <div class="subtitulo white" v-html="subtitulo"></div>
          <div class="conteudo white" v-html="conteudo"></div>
        </div>
      </div>
      <div class="btn flex w-full lg:w-5">
        <div @click="fc_goRoute('contactos')" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_agendarDemo')"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    titulo: String,
    subtitulo: String,
    conteudo: String
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.homeDemo {
  background: url("@/assets/banners/contab.jpg") no-repeat center center;
  background-attachment: fixed;
  background-size: cover;
}
.homeDemo .homepage-title-group {
  margin-top: 100px;
  margin-bottom: 100px;
}
.homeDemo .btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width:1040px) {
  .homeDemo .homepage-title-group {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}
@media screen and (max-width:992px) {
  .homeDemo .btn-redireciona {
    margin-bottom: 40px;
  }
}
</style>
